module.exports = {"useDummyData":0,"rootSite":"","loginAction":"/api/login","billboardAction":"/api/Billboards","imageUploadAction":"/api/ImageUpload","aboutAction":"/api/Abouts/1","footerAction":"/api/Footers/1","newsItemsAction":"/api/NewsItems","caseItemsAction":"/api/CaseItems","productsAction":"/api/Products","productLinesAction":"/api/ProductLines"}


//////////////////
// WEBPACK FOOTER
// ./src/dummy_data/configuration.json
// module id = 22
// module chunks = 0